/* GMU product page (T5). Source: gmu-audit/mockups/final/product.html.
   gmu-product: size buttons <-> hidden variant input <-> sticky bar select, add to cart into the EXISTING theme
   cart drawer (cart-drawer.renderContents, same as product-form.js), Find my size dialog, gallery dots,
   Pairs well with + You may also like via the recommendations endpoint.
   gmu-lightbox: fullscreen photo viewer, click/tap toggles 2x zoom following the pointer, drag pans on touch. */
(function () {
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) return Shopify.formatMoney(cents, window.money_format);
    return (cents / 100).toFixed(2);
  }

  /* add to cart + open the drawer: shared helper in assets/gmu-quickadd.js (loaded on every page in layout/theme.liquid) */
  function cartAdd(body, isJson) { return window.gmuCartAdd(body, isJson); }

  class GmuProduct extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      /* Feed the theme's own Recently viewed section (sections/recently-viewed-products.liquid reads product ids from
         localStorage "_halo_recently_viewed", which the old product page wrote in product-info.js setRecentlyViewed). */
      try {
        var rvId = parseInt(this.dataset.productId, 10);
        if (rvId) {
          var rv = JSON.parse(localStorage.getItem('_halo_recently_viewed') || '[]').filter(function (x) { return x !== rvId; });
          rv.unshift(rvId);
          localStorage.setItem('_halo_recently_viewed', JSON.stringify(rv.slice(0, 25)));
        }
      } catch (e) {}
      this.input = this.querySelector('[data-variant-input]');
      this.sizes = Array.prototype.slice.call(this.querySelectorAll('[data-sizes] [data-size]'));
      this.barSel = this.querySelector('[data-sbar-size]');
      this.msg = this.querySelector('[data-msg]');
      this.mainAdd = this.querySelector('.gmu-pdp__add');
      this.sbar = this.querySelector('[data-sbar]');
      var self = this;

      this.sizes.forEach(function (b) {
        b.addEventListener('click', function () { if (!b.classList.contains('is-out')) self.pick(b.dataset.size, true); });
      });
      if (this.barSel) {
        Array.prototype.forEach.call(this.barSel.options, function (o) {
          var b = self.sizeBtn(o.value);
          if (b && b.classList.contains('is-out')) o.disabled = true;
        });
        var on = this.querySelector('[data-sizes] .is-on');
        if (on) this.barSel.value = on.dataset.size;
        this.barSel.addEventListener('change', function () { self.pick(self.barSel.value, false); });
      }
      /* arrow keys inside the size radiogroup */
      var group = this.querySelector('[data-sizes]');
      if (group) {
        var cur = group.querySelector('.is-on') || this.sizes.filter(function (b) { return !b.classList.contains('is-out'); })[0];
        this.sizes.forEach(function (b) { b.tabIndex = b === cur ? 0 : -1; });
        group.addEventListener('keydown', function (e) {
          if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var list = self.sizes.filter(function (b) { return !b.classList.contains('is-out'); });
          var i = list.indexOf(document.activeElement);
          var n = list[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length];
          if (n) { self.pick(n.dataset.size, true); n.focus(); }
        });
      }

      var form = this.querySelector('form.gmu-pdp__form');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.add(self.mainAdd); });
      this.querySelectorAll('.gmu-sbar [data-add]').forEach(function (b) { b.addEventListener('click', function () { self.add(b); }); });

      /* sticky bar: desktop shows it once the main Add to cart has scrolled out above; phones always (CSS) */
      if (this.sbar && this.mainAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          self.sbar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(this.mainAdd);
      }

      /* phone gallery dots */
      var g = this.querySelector('[data-gallery]'), dots = this.querySelectorAll('.gmu-pdp__dots i');
      if (g && dots.length) {
        g.addEventListener('scroll', function () {
          var w = g.clientWidth; if (!w) return;
          var i = Math.round(g.scrollLeft / w);
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        }, { passive: true });
      }
      /* gallery_style thumbs: thumbs, arrows and arrow keys move the one photo track (scrollLeft, no page jump);
         scrolling/swiping it marks the thumb and the "1 / N" counter */
      var tg = this.querySelector('[data-gal-thumbs]');
      if (tg && g) {
        var figs = Array.prototype.slice.call(g.querySelectorAll('.gmu-pdp__fig'));
        var thumbs = Array.prototype.slice.call(tg.querySelectorAll('[data-thumb]'));
        var strip = tg.querySelector('.gmu-pdp__thumbs'), num = tg.querySelector('[data-gal-n]'), gi = 0;
        var mark = function (i) {
          gi = i;
          thumbs.forEach(function (t, k) {
            t.classList.toggle('is-on', k === i);
            if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
          });
          if (num) num.textContent = i + 1;
          var t = thumbs[i];
          if (strip && t && strip.scrollHeight > strip.clientHeight) {
            if (t.offsetTop < strip.scrollTop) strip.scrollTop = t.offsetTop;
            else if (t.offsetTop + t.offsetHeight > strip.scrollTop + strip.clientHeight) strip.scrollTop = t.offsetTop + t.offsetHeight - strip.clientHeight;
          }
        };
        var go = function (i) {
          if (figs.length < 2) return;
          i = (i + figs.length) % figs.length;
          g.scrollTo({ left: figs[i].offsetLeft - figs[0].offsetLeft, behavior: 'auto' });
          mark(i);
        };
        thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); }); });
        var pv = tg.querySelector('[data-gal-prev]'), nx = tg.querySelector('[data-gal-next]');
        if (pv) pv.addEventListener('click', function () { go(gi - 1); });
        if (nx) nx.addEventListener('click', function () { go(gi + 1); });
        tg.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          go(gi + (e.key === 'ArrowRight' ? 1 : -1));
          var t = thumbs[gi];
          if (t && document.activeElement && document.activeElement.hasAttribute('data-thumb')) t.focus({ preventScroll: true });
        });
        g.addEventListener('scroll', function () {
          if (figs.length < 2) return;
          var step = figs[1].offsetLeft - figs[0].offsetLeft; if (!step) return;
          var i = g.scrollLeft >= g.scrollWidth - g.clientWidth - 2 ? figs.length - 1 : Math.round(g.scrollLeft / step);
          if (i !== gi) mark(Math.max(0, Math.min(figs.length - 1, i)));
        }, { passive: true });
      }
      this.querySelectorAll('[data-lb-index]').forEach(function (f) {
        f.addEventListener('click', function () {
          var lb = document.querySelector('gmu-lightbox[data-for="' + self.dataset.section + '"]');
          if (lb) lb.open(parseInt(f.dataset.lbIndex, 10), f);
        });
      });

      /* Find my size */
      var dlg = this.querySelector('[data-guide]');
      this.querySelectorAll('[data-open-guide]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
          else { var sc = self.querySelector('.gmu-sg'); if (sc) sc.scrollIntoView(); }
        });
      });
      if (dlg) {
        dlg.querySelector('[data-close-guide]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }
      /* size chart units (custom.size_chart table + general chart) */
      this.addEventListener('click', function (e) {
        var u = e.target.closest('[data-unit]'); if (!u) return;
        /* one toggle drives every unit box in the same size guide (chart + T13 length cards) */
        var scope = u.closest('.gmu-sg, .gmu-sgd') || u.closest('[data-sg-units]');
        scope.querySelectorAll('[data-sg-units]').forEach(function (b) { b.classList.toggle('show-in', u.dataset.unit === 'in'); });
        scope.querySelectorAll('[data-unit]').forEach(function (x) { var on = x.dataset.unit === u.dataset.unit; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      });
      /* G5 real size chart: "More measurements" shows thigh, knee, leg opening, back rise */
      this.addEventListener('click', function (e) {
        var mb = e.target.closest('[data-sg-more]'); if (!mb) return;
        var box = mb.closest('.gmu-sgt'), on = !box.classList.contains('is-more');
        box.classList.toggle('is-more', on);
        mb.setAttribute('aria-expanded', on);
        mb.textContent = on ? mb.dataset.fewer : mb.dataset.more;
      });
      /* general size chart fallback: Midwaist / Highwaist / Antifit tabs (snippets/gmu-size-fallback.liquid) */
      this.addEventListener('click', function (e) {
        var tb = e.target.closest('[data-fit-tab]'); if (!tb) return;
        var box = tb.closest('[data-sg-fit]');
        box.querySelectorAll('[data-fit-tab]').forEach(function (x) { var on = x === tb; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
        box.querySelectorAll('[data-fit-pane]').forEach(function (x) { x.hidden = x.dataset.fitPane !== tb.dataset.fitTab; });
      });

      this.initFbt();
      this.loadRecs();
      this.loadRecent();
    }

    sizeBtn(size) {
      for (var i = 0; i < this.sizes.length; i++) if (this.sizes[i].dataset.size === size) return this.sizes[i];
      return null;
    }

    pick(size, fromButton) {
      var btn = this.sizeBtn(size);
      if (!btn || btn.classList.contains('is-out')) return;
      this.sizes.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      this.input.value = btn.dataset.variant;
      if (this.barSel && this.barSel.value !== size) this.barSel.value = size;
      this.querySelectorAll('[data-size-name]').forEach(function (x) { x.textContent = size; });
      var price = parseInt(btn.dataset.cents, 10), cmp = parseInt(btn.dataset.compare, 10);
      this.querySelectorAll('.gmu-pdp__price [data-price], .gmu-sbar__pr').forEach(function (x) { x.textContent = money(price); });
      var pb = this.querySelector('.gmu-pdp__price');
      var showCmp = !!pb && pb.dataset.showCompare === 'true' && cmp > price;
      var c = this.querySelector('[data-compare]');
      if (c) { c.hidden = !showCmp; if (showCmp) c.textContent = money(cmp); }
      var sv = this.querySelector('[data-save]');
      if (sv) { sv.hidden = !showCmp; if (showCmp) sv.textContent = (sv.dataset.tpl || '%A%').replace('%A%', money(cmp - price)); }
      var fm = this.querySelector('[data-fbt-price-main]');
      if (fm) { fm.textContent = money(price); fm.dataset.cents = price; }
      this.querySelectorAll('.gmu-sgt [data-size]').forEach(function (x) { x.classList.toggle('is-sel', x.dataset.size === size); });
      if (this.msg) this.msg.textContent = '';
      /* Lupe P3 (E3): "Only N left" comes from the size button (real stock, set in Liquid); none = empty line */
      var low = this.querySelector('[data-low-line]');
      if (low) low.textContent = btn.dataset.low || '';
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.variant);
        history.replaceState(history.state, '', url.toString());
      }
      this.updateFbt();
    }

    needSize(trigger) {
      if (!this.sizes.length || this.input.value) return false;
      if (this.msg) this.msg.textContent = this.msg.dataset.text || (window.gmuStrings && gmuStrings.chooseSize) || '';
      var group = this.querySelector('[data-sizes]');
      group.classList.remove('is-shake'); void group.offsetWidth; group.classList.add('is-shake');
      if (trigger && trigger !== this.mainAdd) group.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var first = this.sizes.filter(function (b) { return !b.classList.contains('is-out'); })[0];
      if (first) first.focus({ preventScroll: trigger !== this.mainAdd });
      return true;
    }

    add(trigger) {
      if (this.needSize(trigger)) return;
      if (!this.input.value) return;
      var self = this, fd = new FormData();
      fd.append('id', this.input.value);
      fd.append('quantity', '1');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
      trigger.setAttribute('aria-busy', 'true');
      cartAdd(fd, false)
        .catch(function (err) { if (self.msg) self.msg.textContent = err.message; })
        .finally(function () { trigger.removeAttribute('aria-busy'); });
    }

    /* Pairs well with */
    initFbt() {
      var box = this.querySelector('[data-fbt]');
      if (!box) return;
      this.fbt = box;
      var self = this;
      box.addEventListener('change', function (e) {
        if (e.target.matches('[data-fbt], [data-fbt-select]')) self.updateFbt();
      });
      box.querySelector('[data-fbt-add]').addEventListener('click', function (e) { self.addFbt(e.currentTarget); });
      if (box.querySelector('[data-fbt-part]')) this.placeFbt(box);
      else if (box.dataset.recsUrl) {
        this.fetchFrag(box.dataset.recsUrl).then(function (frag) {
          if (!frag || !frag.querySelector('[data-fbt-part="item"]')) return;
          box.querySelector('[data-fbt-pair]').appendChild(frag.querySelector('[data-fbt-part="item"]'));
          var row = frag.querySelector('[data-fbt-part="row"]');
          if (row) box.querySelector('[data-fbt-pair]').appendChild(row);
          self.placeFbt(box);
          box.hidden = false;
        });
      }
    }

    placeFbt(box) {
      var row = box.querySelector('[data-fbt-part="row"]');
      if (row) { var li = row.querySelector('li'); if (li) box.querySelector('[data-fbt-rows]').appendChild(li); row.remove(); }
      this.updateFbt();
    }

    updateFbt() {
      var box = this.fbt; if (!box) return;
      var btn = box.querySelector('[data-fbt-add]'), total = 0, n = 0;
      var main = box.querySelector('[data-fbt-price-main]');
      var mainCents = main && main.dataset.cents ? parseInt(main.dataset.cents, 10) : null;
      if (mainCents === null) {
        var on = this.querySelector('[data-sizes] .is-on') || this.sizes.filter(function (b) { return !b.classList.contains('is-out'); })[0];
        mainCents = on ? parseInt(on.dataset.cents, 10) : 0;
      }
      box.querySelectorAll('input[data-fbt]').forEach(function (x) {
        var id = x.dataset.fbt, cents = 0;
        if (id === '1') cents = mainCents;
        else {
          var sel = x.closest('li').querySelector('[data-fbt-select]');
          var opt = sel && sel.options[sel.selectedIndex];
          cents = opt ? parseInt(opt.dataset.cents, 10) : 0;
          var pr = x.closest('li').querySelector('[data-fbt-price]');
          if (pr) pr.textContent = money(cents);
        }
        if (x.checked) { total += cents; n++; }
        var it = box.querySelector('[data-fbt-item="' + id + '"]');
        if (it) it.classList.toggle('is-off', !x.checked);
      });
      box.querySelector('[data-fbt-total]').textContent = money(total);
      box.querySelector('[data-fbt-label]').textContent = n === 2 ? btn.dataset.lTotalBoth : btn.dataset.lTotal;
      btn.textContent = n === 2 ? btn.dataset.lBoth : btn.dataset.lOne;
      btn.disabled = n === 0;
    }

    addFbt(btn) {
      var box = this.fbt, items = [], wantMain = false, self = this;
      box.querySelectorAll('input[data-fbt]').forEach(function (x) {
        if (!x.checked) return;
        if (x.dataset.fbt === '1') { wantMain = true; return; }
        var sel = x.closest('li').querySelector('[data-fbt-select]');
        if (sel && sel.value) items.push({ id: parseInt(sel.value, 10), quantity: 1 });
      });
      var fmsg = box.querySelector('[data-fbt-msg]');
      if (wantMain) {
        if (this.needSize(btn)) { if (fmsg) fmsg.textContent = this.msg ? this.msg.textContent : ''; return; }
        items.unshift({ id: parseInt(this.input.value, 10), quantity: 1 });
      }
      if (!items.length) return;
      if (fmsg) fmsg.textContent = '';
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
      btn.setAttribute('aria-busy', 'true');
      cartAdd({ items: items }, true)
        .catch(function (err) { if (fmsg) fmsg.textContent = err.message; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    }

    fetchFrag(url) {
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-gmu-recs]');
      }).catch(function () { return null; });
    }

    /* 7 Oct: Recently viewed = ids from localStorage "_halo_recently_viewed" (newest first, this product left out),
       rendered by this section through the search endpoint, then put back in viewed order. */
    loadRecent() {
      if (window.gmuRecent) window.gmuRecent(this.querySelector('.gmu-pdp__rv'), parseInt(this.dataset.productId, 10), this.querySelector('.gmu-pdp__details') || this);
    }

    loadRecs() {
      var sec = this.querySelector('.gmu-pdp__recs');
      if (!sec || !sec.dataset.recsUrl) return;
      var self = this;
      var go = function () {
        self.fetchFrag(sec.dataset.recsUrl).then(function (frag) {
          if (!frag || !frag.querySelector('.gmu-card')) return;
          var tgt = sec.querySelector('[data-recs-target]');
          frag.querySelectorAll('script').forEach(function (s) { s.remove(); });
          tgt.innerHTML = frag.innerHTML;
          if (window.gmuFav) window.gmuFav.syncAll();
          sec.hidden = false;
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); go(); }
        }, { rootMargin: '600px 0px' });
        io.observe(this.querySelector('.gmu-pdp__details') || this);
      } else go();
    }
  }
  if (!customElements.get('gmu-product')) customElements.define('gmu-product', GmuProduct);

  class GmuLightbox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var host = this.closest('.gmu-pdp-sec');
      var prod = host && host.querySelector('gmu-product');
      this.figs = prod ? Array.prototype.slice.call(prod.querySelectorAll('[data-lb-index]')) : [];
      if (prod) this.dataset.for = prod.dataset.section;
      /* move to <body>: #MainContent is a z-index stacking context below the sticky header.
         Editor re-render: drop the old moved copy for this section first; it goes with the section on unload. */
      if (prod) {
        var sid = prod.dataset.section;
        document.querySelectorAll('body > gmu-lightbox[data-for="' + sid + '"]').forEach(function (o) { if (o !== this) o.remove(); }, this);
        var self0 = this;
        document.addEventListener('shopify:section:unload', function h(e) {
          if (e.detail && e.detail.sectionId === sid) { self0.remove(); document.removeEventListener('shopify:section:unload', h); }
        });
      }
      document.body.appendChild(this);
      var self = this;
      this.stage = this.querySelector('[data-stage]');
      this.img = this.querySelector('[data-img]');
      this.count = this.querySelector('[data-count]');
      this.fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      this.querySelector('[data-hint]').textContent = this.fine ? this.dataset.hintFine : this.dataset.hintTouch;
      this.idx = 0; this.zoom = false; this.tx = 0; this.ty = 0; this.last = null;
      this.querySelector('[data-close]').addEventListener('click', function () { self.close(); });
      var pv = this.querySelector('[data-prev]'), nx = this.querySelector('[data-next]');
      if (pv) pv.addEventListener('click', function () { self.show(self.idx - 1); });
      if (nx) nx.addEventListener('click', function () { self.show(self.idx + 1); });
      this.onKey = function (e) {
        if (self.hidden) return;
        if (e.key === 'Escape') self.close();
        else if (e.key === 'ArrowLeft') self.show(self.idx - 1);
        else if (e.key === 'ArrowRight') self.show(self.idx + 1);
        else if (e.key === 'Tab') {
          var f = Array.prototype.slice.call(self.querySelectorAll('button'));
          var i = f.indexOf(document.activeElement);
          /* i < 0: a click on the photo moved focus to <body>, pull it back inside */
          if (i < 0) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
          else if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
        }
      };
      var st = this.stage;
      st.addEventListener('pointerdown', function (e) {
        self.last = { sx: e.clientX, sy: e.clientY, tx: self.tx, ty: self.ty, moved: false };
        if (!self.fine && self.zoom) st.setPointerCapture(e.pointerId);
      });
      st.addEventListener('pointermove', function (e) {
        if (self.fine) { if (self.zoom) { self.classList.add('is-moving'); self.aim(e.clientX, e.clientY); self.apply(); } return; }
        if (!self.last) return;
        var dx = e.clientX - self.last.sx, dy = e.clientY - self.last.sy;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) self.last.moved = true;
        if (self.zoom) { self.tx = self.last.tx + dx; self.ty = self.last.ty + dy; self.clamp(); self.classList.add('is-moving'); self.apply(); }
      });
      st.addEventListener('pointerup', function (e) {
        if (!self.last) return;
        var dx = e.clientX - self.last.sx, dy = e.clientY - self.last.sy;
        var moved = self.last.moved || Math.abs(dx) > 8 || Math.abs(dy) > 8;
        self.classList.remove('is-moving');
        if (!moved) self.setZoom(!self.zoom, e.clientX, e.clientY);
        else if (!self.zoom && !self.fine && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) self.show(self.idx + (dx < 0 ? 1 : -1));
        self.last = null;
      });
      st.addEventListener('pointercancel', function () { self.last = null; self.classList.remove('is-moving'); });
      st.addEventListener('wheel', function (e) {
        e.preventDefault();
        if (e.deltaY < 0 && !self.zoom) self.setZoom(true, e.clientX, e.clientY);
        else if (e.deltaY > 0 && self.zoom) self.setZoom(false);
      }, { passive: false });
      window.addEventListener('resize', function () { if (self.zoom) { self.clamp(); self.apply(); } });
    }
    apply() { this.img.style.transform = this.zoom ? 'translate(' + this.tx + 'px,' + this.ty + 'px) scale(2)' : ''; }
    clamp() {
      var w = this.img.offsetWidth, h = this.img.offsetHeight, sw = this.stage.clientWidth, sh = this.stage.clientHeight;
      var mx = Math.max(0, (2 * w - sw) / 2), my = Math.max(0, (2 * h - sh) / 2);
      this.tx = Math.max(-mx, Math.min(mx, this.tx)); this.ty = Math.max(-my, Math.min(my, this.ty));
    }
    aim(x, y) {
      var r = this.stage.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var w = this.img.offsetWidth, h = this.img.offsetHeight;
      var mx = Math.max(0, (2 * w - r.width) / 2), my = Math.max(0, (2 * h - r.height) / 2);
      this.tx = -((x - cx) / (r.width / 2)) * mx; this.ty = -((y - cy) / (r.height / 2)) * my; this.clamp();
    }
    setZoom(on, x, y) {
      this.zoom = on; this.classList.toggle('is-zoom', on);
      if (on && x != null) this.aim(x, y); else { this.tx = 0; this.ty = 0; }
      this.apply();
    }
    show(i) {
      var n = this.figs.length; if (!n) return;
      this.idx = (i + n) % n;
      this.setZoom(false);
      var f = this.figs[this.idx];
      this.img.src = f.dataset.zoom; this.img.alt = f.dataset.alt || '';
      this.count.textContent = (this.idx + 1) + ' / ' + n;
    }
    open(i, from) {
      this.lastFocus = from || document.activeElement;
      this.show(i);
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      this.querySelector('[data-close]').focus();
    }
    close() {
      this.hidden = true; this.setZoom(false);
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      if (this.lastFocus) this.lastFocus.focus();
    }
  }
  if (!customElements.get('gmu-lightbox')) customElements.define('gmu-lightbox', GmuLightbox);
})();
